import { PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { useBooleanState } from '@toss/react';
import { useRouter } from 'next/router';
import { GoogleAnalytics, NaverAnalytics } from '@zep/analytics';
import { DialogProvider, Toast } from '@zep/dialog';
import { AcceptCookieWrapper } from '@zep/web-components';
import { initSentry } from '../../utils';
import { grantGtmMarketingConsent } from '../../utils/gtmMarketingEvent';
const RootLayout = (props: RootLayoutProps) => {
  const {
    children,
    onCookiePanelVisibilityChange
  } = props;
  const router = useRouter();
  const [, setShowCookiePanel] = useState(false);
  const [isAllowedAnalytics, allowAnalytics] = useBooleanState(true);
  const enabledCookieAccept = !router.pathname.includes('/web3');

  // 쿠키 동의 시 GA 로드와 함께 GTM Consent Mode도 granted로 전환한다.
  // (_document.tsx에서 기본값 denied로 초기화됨)
  const handleAcceptedCookie = useCallback(() => {
    allowAnalytics();
    grantGtmMarketingConsent();
  }, [allowAnalytics]);
  useEffect(() => {
    initSentry();
  }, []);
  return <DialogProvider data-sentry-element="DialogProvider" data-sentry-component="RootLayout" data-sentry-source-file="RootLayout.tsx">
      <AcceptCookieWrapper enabledCookiePanel={enabledCookieAccept} onAcceptedCookie={handleAcceptedCookie} updateVisibilityCookiePanel={isVisible => {
      setShowCookiePanel(isVisible);
      onCookiePanelVisibilityChange?.(isVisible);
    }} data-sentry-element="AcceptCookieWrapper" data-sentry-source-file="RootLayout.tsx">
        {children}
        <div id="tooltip" />
        <Toast data-sentry-element="Toast" data-sentry-source-file="RootLayout.tsx" />
        {isAllowedAnalytics && <GoogleAnalytics />}
        {isAllowedAnalytics && <NaverAnalytics />}
      </AcceptCookieWrapper>
    </DialogProvider>;
};
export default RootLayout;
type RootLayoutProps = PropsWithChildren<{
  onCookiePanelVisibilityChange?: (isVisible: boolean) => void;
}>;